import { hideOthers } from "aria-hidden"
import { useEffect } from "react"

export default function useAriaHidden({ ref, enabled = true, shards = [] }) {
  useEffect(() => {
    let unhide = () => null

    if (enabled && ref.current) {
      unhide = hideOthers([ref.current, ...(shards || [])])
    } else if (!enabled) {
      unhide()
    }

    return () => unhide()
  }, [shards, enabled])

  return null
}
